module.exports = __webpack_public_path__ + "static/img/block06.b8e5408b.png";